import loadSelectedLanguage from '../events/loadSelectedLanguage';
import { DOM_IDS } from '../utils/constants';
export default function languageSelector() {
  const languageSelect = document.getElementById(DOM_IDS.languageSelect);
  if (languageSelect) {
    languageSelect.onchange = function () {
      const currentSelect = languageSelect;
      loadSelectedLanguage(currentSelect.value);
    };
  }
}